import { Trans } from '@lingui/macro'
import React from 'react'
import { InputField } from 'webbook-airways'

export default function InputFieldRegion(props) {
  return (
    <InputField
      autoComplete="new-password"
      label={<Trans>Region</Trans>}
      {...props}
    />
  )
}
